import Swal from 'sweetalert2';

export default class TaskManager {
    #element;

    constructor(element) {
        this.#element = element;

        this.#bindEvents();
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new TaskManager(element));
    }

    #bindEvents() {
        this.#element.addEventListener('click', this.#processStatus);
    }

    #processStatus = () => {
        window
            .HttpClient
            .get(this.#element.dataset.toggleUrl)
            .then(this.#toggleStatus)
            .catch(this.#unableToLoad);
    };

    #toggleStatus(response) {
        let task = document.getElementById('task_' + response.data.id);

        task.classList.toggle('bg-light', response.data.completed);

        let completeIcon = document.getElementById('task_' + response.data.id + '_complete');
        let incompleteIcon = document.getElementById('task_' + response.data.id + '_incomplete');

        completeIcon.classList.toggle('d-none', !response.data.completed);
        incompleteIcon.classList.toggle('d-none', response.data.completed);

        if (! document.getElementById('filter_include_completed').checked && response.data.completed === true) {
            document
                .getElementById('task_' + response.data.id)
                .classList
                .toggle('d-none', true);

            document.getElementById('task_total').textContent = document.getElementById('task_total').textContent - 1;
        }
    }

    #unableToLoad() {
        Swal.fire({
            icon: 'error',
            title: 'Oeps...',
            text: 'Kan de status van de taak niet wijzigen!',
        });
    }
}
